<template lang="pug">
  .component-search-vehicle-availability
    h2 Extend reservation
    loading-spinner(v-if="loading")
    backoffice-vehicle-availability(v-if="availability.length", :availability.sync="availability", @slotsSelected="slotSelected", :selectable="selectable", :extend="true", @loadExtra="showExtraDay")
</template>
<script type="text/babel">
  import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
  import BackofficeVehicleAvailability from './VehicleAvailability'
  import DatePicker from '../structure/DatePicker'
  import LoadingSpinner from '../structure/LoadingSpinner'
  import MaggieHelper from '../../maggieHelper'

  export default {
    name: 'ExtendReservation',
    components: {
      LoadingSpinner,
      DatePicker,
      BackofficeVehicleAvailability,
    },
    data() {
      return {
        availability: [],
        start: null,
        end: null,
        loading: false
      }
    },
    created() {
      this.start = this.$date(this.reservation.end)
      this.end = this.$date(this.reservation.end).add(1, 'days').hours(23).minutes(30).seconds(0)
      this.loading = true
      this.getAvailability()
    },
    methods: {
      slotSelected(obj) {
        console.log(obj)
        KeplerBackofficeSdk.reservations.select(this.reservation).extend(obj.end, () => {
          MaggieHelper.closeTopPanel()
          MaggieHelper.notification('Extended', 'Reservation extended correctly')
        })
        // this.$emit('slotsSe.lected', obj)
      },
      search() {
        this.start = this.$date(this.start)
        this.end = this.$date(this.end)
        this.getAvailability()
      },
      getAvailability() {

        KeplerBackofficeSdk.vehicles.select(this.reservation.vehicle, {
          start: this.start.unix(),
          end: this.end.unix()
        }).availability((data) => {
          data.forEach((a, i) => {

            Object.assign(a, {selected: false})

          })
          this.loading = false
          this.availability = data
        })
      },
      showExtraDay() {
        this.end = this.$date(this.end).add(1, 'days').hours(23).minutes(30).seconds(0)
        this.getAvailability()
      }
    },
    computed: {},
    props: ['selectable', 'reservation'],
  }
</script>
<style lang="sass" rel="stylesheet/sass">
  .component-tabbed-vehicle-availability
    background: white

</style>



// WEBPACK FOOTER //
// ExtendReservation.vue?8639018c